import {
    ChevronDoubleLeftIcon,
    ChevronDoubleRightIcon,
    ChevronLeftIcon,
    ChevronRightIcon
} from '@heroicons/react/outline';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { noop } from '../../utils';



export const PaginationFilterComponent = ({
    doPage = () => noop(),
    limit = 20,
    maxRecords = 0,
    reset = noop(),
    page: controlledPage,
}: {
    doPage: (page: number) => void;
    limit?: number;
    maxRecords?: number;
    reset?: string | null;
    page?: number | null;
}) => {
    const { t } = useTranslation();
    const [internalPage, setInternalPage] = useState<number>(0);
    const page = typeof controlledPage === 'number' ? controlledPage : internalPage;
    const setPage = typeof controlledPage === 'number' ? doPage : setInternalPage;

    const totalPages = Math.max(1, Math.ceil(maxRecords / limit));
    const currentPage = page + 1;

    const goFirst = () => setPage(0);
    const goPrev = () => setPage(Math.max(0, page - 1));
    const goNext = () => setPage(Math.min(totalPages - 1, page + 1));
    const goLast = () => setPage(totalPages - 1);

    return (
        <div
            className={
                'flex flex-1 justify-center items-center mt-8 space-x-2 py-4 rounded-md  bg-transparent'
            }
        >
            <button
                className={'hover:bg-gray p-2 rounded-md disabled:opacity-10'}
                onClick={goFirst}
                disabled={page === 0}
            >
                <ChevronDoubleLeftIcon className={'h-4 w-4'} />
            </button>
            <button
                className={'hover:bg-gray p-2 rounded-md disabled:opacity-10'}
                onClick={goPrev}
                disabled={page === 0}
            >
                <ChevronLeftIcon className={'h-4 w-4'} />
            </button>

            <div className={'text-xs text-gray-darker'}>{`${t(
                'common.label.page'
            )} ${currentPage} ${t('common.label.de')} ${totalPages}`}</div>
            <button
                className={'hover:bg-gray p-2 rounded-md disabled:opacity-10'}
                onClick={goNext}
                disabled={currentPage >= totalPages}
            >
                <ChevronRightIcon className={'h-4 w-4'} />
            </button>
            <button
                className={'hover:bg-gray p-2 rounded-md disabled:opacity-10'}
                onClick={goLast}
                disabled={currentPage >= totalPages}
            >
                <ChevronDoubleRightIcon className={'h-4 w-4'} />
            </button>
        </div>
    );
};
